<template>
  <v-container fluid>
    <v-toolbar flat color="blue-grey lighten-4">
      <span class="font-weight-medium">บัตร</span>
      <v-scroll-x-transition>
        <v-row align="center" v-show="!cardFormShow">
          <v-spacer></v-spacer>
          <v-btn
            :disabled="uiCtrl && !uiCtrl.isEnable('btn:::card:create')"
            color="primary"
            @click="handleAddCard"
          >
            <v-icon small left>mdi-plus</v-icon>เพิ่มบัตร
          </v-btn>
          <v-menu min-width="200">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list nav dense>
              <v-list-item
                link
                :disabled="
                  uiCtrl &&
                  !uiCtrl.isEnable('btn:::import_data:import_csv:card:post')
                "
                @click="uploadDialog = true"
              >
                <v-list-item-icon>
                  <v-icon>mdi-import</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>นำเข้าข้อมูล</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-row>
      </v-scroll-x-transition>
    </v-toolbar>
    <v-card outlined class="px-3 py-3 mb-2">
      <v-row align="center">
        <v-col md="3" lg="3" xl="2">
          <v-text-field
            v-model="search"
            placeholder="หมายเลขบัตร"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            outlined
            dense
            hide-details
            @input="handleSearch"
          ></v-text-field>
        </v-col>
        <v-col md="3" lg="3" xl="2">
          <v-autocomplete
            v-model="filterCardType"
            :items="cardTypes"
            item-text="title_th"
            item-value="title_th"
            label="ประเภทบัตร"
            prepend-inner-icon="mdi-filter-variant"
            clearable
            flat
            outlined
            dense
            hide-details
            @change="handleFilterCardType"
          ></v-autocomplete>
        </v-col>
        <v-col md="3" lg="3" xl="2">
          <v-autocomplete
            v-model="filterCardMaterial"
            :items="cardMaterials"
            item-text="title_th"
            item-value="title_th"
            label="ประเภทวัสดุ"
            prepend-inner-icon="mdi-filter-variant"
            clearable
            flat
            outlined
            dense
            hide-details
            @change="handleFilterCardMaterial"
          ></v-autocomplete>
        </v-col>
        <v-col md="3" lg="3" xl="2">
          <v-select
            v-model="filterCardAssignment"
            :items="[
              { id: 1, text: 'เชื่อมโยงแล้ว', value: 'assignment' },
              { id: 2, text: 'ยังไม่เชื่อมโยง', value: 'not-assignment' },
            ]"
            item-text="text"
            item-value="value"
            label="เชื่อมโยงบัตร"
            prepend-inner-icon="mdi-filter-variant"
            clearable
            flat
            outlined
            dense
            hide-details
            @change="handleFilterCardAssignment"
          >
          </v-select>
        </v-col>
      </v-row>
    </v-card>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :headers="headers"
      :items="cards"
      :options.sync="options"
      :server-items-length="totalCards"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.card_assignments="{ item }">
        <div v-if="item.card_assignments && item.card_assignments.length > 0">
          {{ item.card_assignments[0].card_holder.firstname_th }}
          {{ item.card_assignments[0].card_holder.lastname_th }}
        </div>
        <div v-else>-</div>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          color="grey"
          :disabled="
            !item.card_assignments || item.card_assignments.length === 0
          "
          @click.stop="handleDeleteAssignment(item)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <CardFormView
      :formShow="cardFormShow"
      :formShowAt="cardFormShowAt"
      :formAction="cardFormAction"
      :card="card"
      :cardInit="cardInit"
      @isCardDataChange="handleCardFormDataChange"
      @formActionCompleted="handleCardFormActionCompleted"
      @onReset="handleCardFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="cardFormShow && cardFormAction === 'add'"
      z-index="0"
    ></v-overlay>
    <v-dialog v-model="dialogProgress" persistent width="320">
      <div class="pa-4 white">
        <v-progress-linear :value="progressValue" height="25">
          <strong>{{ Math.ceil(progressValue) }}%</strong>
        </v-progress-linear>
      </div>
    </v-dialog>
    <UploadDialog
      :uploadDialog="uploadDialog"
      uploadDialogTitle="นำเข้าข้อมูลบัตร"
      :downloadExampleFileImportDataUrl="exampleFileImportDataUrl"
      downloadExampleFileImportDataName="card.csv"
      @selectedFile="selectedFile"
      @handleCancelUploadDialog="handleCancelUploadDialog"
      @uploadFile="uploadFile"
    />
    <UploadDialogMessage
      :uploadDialogMessage="uploadDialogMessage"
      uploadDialogMessageTitle="นำเข้าข้อมูลบัตรไม่สำเร็จ"
      :downloadFileImportDataUrl="fileImportDataUrl"
      :downloadFileImportDataName="fileImportDataName"
      @onClose="uploadDialogMessage = false"
    />
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
    <ConfirmDialog
      :dialog="confirmDialogDeleteAssignment"
      :loading="confirmDialogDeleteAssignmentLoading"
      :dialogData="confirmDialogDeleteAssignmentData"
      @cancelConfirmDialog="cancelConfirmDialogDeleteAssignment"
      @submitConfirmDialog="submitConfirmDialogDeleteAssignment"
    />
  </v-container>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import UploadDialog from '@/components/UploadDialog.vue'
import UploadDialogMessage from '@/components/UploadDialogMessage.vue'
import CardFormView from '@/views/card/CardFormView.vue'

export default {
  components: {
    CardFormView,
    ConfirmDialog,
    UploadDialog,
    UploadDialogMessage,
  },
  data() {
    return {
      confirmDialogDeleteAssignment: false,
      confirmDialogDeleteAssignmentLoading: false,
      confirmDialogDeleteAssignmentData: {},
      dialogForbidden: false,
      fileImportDataUrl: '',
      fileImportDataName: '',
      dialogProgress: false,
      progressValue: 0,
      sortBy: ['card_type.title_th'],
      sortDesc: [false],
      currentFile: null,
      uploadDialog: false,
      uploadDialogMessage: false,
      uploadFail: [],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: false,
      options: {},
      search: '',
      filterCardType: null,
      filterCardMaterial: null,
      filterCardAssignment: null,
      cardFormShow: false,
      cardFormShowAt: '',
      cardFormAction: '',
      card: {
        card_type: {},
        card_material: {},
        card_identifiers: [],
      },
      cardInit: {
        card_type: {},
        card_material: {},
        card_identifiers: [],
      },
      isCardDataChange: false,
      interval: null,
      timeout: null,
      headers: [
        {
          text: 'ประเภทบัตร',
          value: 'card_type.title_th',
        },
        {
          text: 'ประเภทวัสดุ',
          value: 'card_material.title_th',
        },
        {
          text: 'หมายเลขบัตร',
          value: 'card_number',
        },
        {
          text: 'เชื่อมโยงบัตร',
          value: 'card_assignments',
          sortable: false,
        },
        {
          text: 'ยกเลิกเชื่อมโยง',
          align: 'center',
          width: '110',
          value: 'actions',
          sortable: false,
        },
      ],
    }
  },
  watch: {
    options: {
      handler() {
        this.getCards()
      },
      deep: true,
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    cardTypes() {
      return this.$store.state.card.cardTypes
    },
    cardMaterials() {
      return this.$store.state.card.cardMaterials
    },
    cards() {
      return this.$store.state.card.cards
    },
    totalCards() {
      return this.$store.state.card.totalCards
    },
    exampleFileImportDataUrl() {
      return this.$store.state.download.exampleFileImportDataUrl
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'บัตร',
        disabled: true,
      },
    ])

    const { company_uuid } = this.$store.state.authentication.company

    Promise.all([
      this.fetchCardTypes({
        company_uuid,
        params: {
          dpc: 'card-to-list-card-type',
        },
      }),
      this.fetchCardMaterials(),
      this.fetchCardIdentifierTypes(),
      this.downloadExampleFileImportData({
        uuid: company_uuid,
        exampleFileType: 'card',
      }),
    ])
      .then(() => {
        this.loading = false
      })
      .catch((error) => {
        this.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
  },
  methods: {
    ...mapActions({
      fetchCards: 'card/fetchCards',
      fetchCardTypes: 'card/fetchCardTypes',
      fetchCardMaterials: 'card/fetchCardMaterials',
      fetchCardIdentifierTypes: 'card/fetchCardIdentifierTypes',
      uploadFileImportData: 'upload/uploadFileImportData',
      downloadExampleFileImportData: 'download/downloadExampleFileImportData',
      generateFileProgress: 'download/generateFileProgress',
      deleteEmployeeCard: 'employee/deleteEmployeeCard',
    }),
    handleDeleteAssignment(item) {
      this.confirmDialogDeleteAssignment = true
      this.confirmDialogDeleteAssignmentData = {
        title: 'ยืนยันการยกเลิกเชื่อมโยงบัตร',
        text: 'คุณต้องยกเลิกเชื่อมโยงบัตร',
        value: `${item.card_type.title_th} : ${item.card_assignments[0].card_holder.firstname_th} ${item.card_assignments[0].card_holder.lastname_th}`,
        item,
      }
    },
    cancelConfirmDialogDeleteAssignment() {
      this.confirmDialogDeleteAssignment = false
    },
    submitConfirmDialogDeleteAssignment(item) {
      this.confirmDialogDeleteAssignmentLoading = true

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        employee_uuid: item.card_assignments[0].card_holder.employee_uuid,
        card_uuid: item.card_uuid,
      }

      this.deleteEmployeeCard(payload)
        .then((data) => {
          this.confirmDialogDeleteAssignmentLoading = false
          this.confirmDialogDeleteAssignment = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'ลบข้อมูลสำเร็จ',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)

          this.getCards()
        })
        .catch((error) => {
          this.confirmDialogDeleteAssignmentLoading = false
          this.confirmDialogDeleteAssignment = false

          if (error.response && error.response.status === 403) {
            this.dialogForbidden = true
            return
          }

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    handleSearch() {
      this.loading = true
      this.getCardsBySearch()
    },
    handleFilterCardType() {
      this.options.page = 1
      this.getCards()
    },
    handleFilterCardMaterial() {
      this.options.page = 1
      this.getCards()
    },
    handleFilterCardAssignment() {
      this.options.page = 1
      this.getCards()
    },
    getCardsBySearch: _.debounce(function () {
      this.options.page = 1
      this.getCards()
    }, 1000),
    selectedFile(file) {
      this.currentFile = file
    },
    handleCancelUploadDialog(refs) {
      this.uploadDialog = false
      this.currentFile = null
      refs.clearableCallback()
    },
    uploadFile(refs) {
      if (this.currentFile) {
        let formData = new FormData()
        formData.append('file', this.currentFile)

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          uuid: company_uuid,
          fileType: 'card',
          formData: formData,
        }

        this.$store.state.loading = true

        this.uploadFileImportData(payload)
          .then((data) => {
            this.$store.state.loading = false
            this.uploadDialog = false
            refs.clearableCallback()

            this.progressValue = 0
            this.dialogProgress = true
            this.uploadProgress(data.job_process_uuid, data.ping_after_ms)
          })
          .catch((error) => {
            this.$store.state.loading = false
            this.uploadDialog = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      } else {
        const snackbar = {
          show: true,
          color: 'warning',
          timeout: 4000,
          message: 'ไม่ได้เลือกไฟล์ใด',
        }

        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    uploadProgress(job_process_uuid, ping_after_ms) {
      this.interval = setInterval(() => {
        this.generateFileProgress(job_process_uuid)
          .then((res) => {
            if (res.is_success) {
              this.progressValue = 100
              this.timeout = setTimeout(() => {
                this.dialogProgress = false
              }, 200)

              clearInterval(this.interval)

              if (res.resource_json?.total_fail > 0) {
                const fileUrl = res.resource_uri
                const fileName = fileUrl.split('/').pop()
                this.fileImportDataUrl = fileUrl
                this.fileImportDataName = fileName
                this.timeout = setTimeout(() => {
                  this.uploadDialogMessage = true
                }, 300)
              } else {
                this.getCards()

                this.timeout = setTimeout(() => {
                  const snackbar = {
                    show: true,
                    color: 'success',
                    timeout: 3000,
                    message: 'นำเข้าข้อมูลสำเร็จ',
                  }

                  this.$store.commit('SET_SNACKBAR', snackbar)
                }, 300)
              }
            } else {
              this.progressValue = (100 / res.total) * res.progress
            }
          })
          .catch((error) => {
            clearInterval(this.interval)
            this.dialogProgress = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)

            clearInterval(this.interval)
          })
      }, ping_after_ms)
    },
    classRowSelected(row) {
      if (this.card.card_uuid === row.card_uuid) return 'row-selected'
    },
    setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::card:get')) {
        this.dialogForbidden = true
        return
      }

      if (this.card.card_uuid === row.card_uuid) {
        this.cardFormShow = false
        this.cardFormShowAt = ''
        this.cardFormAction = ''
        this.card = {
          card_type: {},
          card_material: {},
          card_identifiers: [],
        }
        this.cardInit = {
          card_type: {},
          card_material: {},
          card_identifiers: [],
        }
      } else {
        this.cardFormShow = true
        this.cardFormShowAt = 'card'
        this.cardFormAction = 'edit'

        this.card = {
          ...row,
          card_type: row.card_type ? { ...row.card_type } : {},
          card_material: row.card_material ? { ...row.card_material } : {},
          card_identifiers: row.card_identifiers.map((item) => {
            return {
              ...item,
              card_identifier_type: { ...item.card_identifier_type },
              default_display_encoding: { ...item.default_display_encoding },
              sn: { ...item.sn },
              issue_datetime: item.issue_datetime
                ? new Date(item.issue_datetime)
                : null,
              expire_datetime: item.expire_datetime
                ? new Date(item.expire_datetime)
                : null,
              freeze_datetime: item.freeze_datetime
                ? new Date(item.freeze_datetime)
                : null,
              discard_datetime: item.discard_datetime
                ? new Date(item.discard_datetime)
                : null,
            }
          }),
        }
        this.cardInit = {
          ...row,
          card_type: row.card_type ? { ...row.card_type } : {},
          card_material: row.card_material ? { ...row.card_material } : {},
          card_identifiers: row.card_identifiers.map((item) => {
            return {
              ...item,
              card_identifier_type: { ...item.card_identifier_type },
              default_display_encoding: { ...item.default_display_encoding },
              sn: { ...item.sn },
              issue_datetime: item.issue_datetime
                ? new Date(item.issue_datetime)
                : null,
              expire_datetime: item.expire_datetime
                ? new Date(item.expire_datetime)
                : null,
              freeze_datetime: item.freeze_datetime
                ? new Date(item.freeze_datetime)
                : null,
              discard_datetime: item.discard_datetime
                ? new Date(item.discard_datetime)
                : null,
            }
          }),
        }
      }
    },
    handleRowSelected(row) {
      if (this.isCardDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddCard() {
      this.cardFormShow = true
      this.cardFormShowAt = 'card'
      this.cardFormAction = 'add'
      this.card = {
        card_type: {},
        card_material: {},
        card_identifiers: [],
      }
      this.cardInit = {
        card_type: {},
        card_material: {},
        card_identifiers: [],
      }
    },
    handleCardFormDataChange(value) {
      this.isCardDataChange = value
    },
    handleCardFormReset(formAction) {
      this.card = JSON.parse(JSON.stringify(this.cardInit))
    },
    handleCardFormActionCompleted(formAction) {
      this.cardFormShow = false
      this.cardFormShowAt = ''
      this.cardFormAction = ''

      this.card = {
        card_type: {},
        card_material: {},
        card_identifiers: [],
      }
      this.cardInit = {
        card_type: {},
        card_material: {},
        card_identifiers: [],
      }
    },
    getCards() {
      this.loading = true

      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      let sort = ''
      const sortByKey = sortBy[0] || ''

      if (sortByKey === 'card_type.title_th') sort = 'card_type_th'
      if (sortByKey === 'card_number') sort = 'card_number'
      if (sortByKey === 'card_material.title_th') sort = 'card_material_th'

      if (sortDesc.length > 0) {
        if (sortDesc[0]) {
          sort += `,desc`
        } else {
          sort += `,asc`
        }
      }

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        params: {
          search: this.search || undefined,
          card_type_uuid: this.filterCardType || undefined,
          card_material_code: this.filterCardMaterial || undefined,
          is_card_assignment: this.filterCardAssignment || undefined,
          sort,
          limit: `${itemsPerPage},${(page - 1) * itemsPerPage}`,
        },
      }

      this.fetchCards(payload)
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.cardFormShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isCardDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
